var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    sessionItemResultsListHeaderWrapperMarginTopBottom: spacing.small,
    sessionItemResultsListHeaderWrapperMarginLeftRight: spacing.large,
    sessionItemResultsListHeaderFontSize: typography.fontSizeXLarge,
    sessionItemResultsListMargin: spacing.xSmall,
    sessionItemResultsListBorderColor: colors.tiara,
    sessionItemResultsListBorderWidth: borders.widthSmall
  };
};
export default generateComponentTheme;